// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Common = require("../utils/Common.res.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_wrk_sort_asrts = require("../worker/MM_wrk_sort_asrts.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Button = require("@mui/material/Button").default;
var Select = require("@mui/material/Select").default;
var MenuItem = require("@mui/material/MenuItem").default;
var InputLabel = require("@mui/material/InputLabel").default;
var ButtonGroup = require("@mui/material/ButtonGroup").default;
var FormControl = require("@mui/material/FormControl").default;
var ArrowUpward = require("@mui/icons-material/ArrowUpward").default;
var ArrowDownward = require("@mui/icons-material/ArrowDownward").default;
var DeleteForever = require("@mui/icons-material/DeleteForever").default;

function renderSortBys(sortBys, onClick, onCancel) {
  var sortByStr = sortBys.map(function (param) {
          return MM_wrk_sort_asrts.sortByGetTitle(param[0]) + " " + MM_wrk_sort_asrts.sortDirToStr(param[1]);
        }).join(", ");
  return React.createElement("span", undefined, React.createElement("span", {
                  className: "dark-grey-bkg-on-hover",
                  style: {
                    cursor: "pointer",
                    borderRadius: "4px"
                  },
                  onClick: (function (param) {
                      onClick();
                    })
                }, "Sorting: " + sortByStr), React.createElement("span", undefined, Common.nbsp), React.createElement("span", {
                  className: "red-on-hover",
                  style: {
                    cursor: "pointer"
                  },
                  onClick: (function (param) {
                      onCancel();
                    })
                }, "\u2715"));
}

function MM_cmp_sort_asrts_selector(props) {
  var onCancel = props.onCancel;
  var onOk = props.onOk;
  var init = props.init;
  var match = React.useState(function () {
        return {
                sortBys: init
              };
      });
  var setState = match[1];
  var state = match[0];
  var rndSortByButtons = function (idx) {
    return React.createElement(ButtonGroup, {
                variant: "outlined",
                size: "small",
                children: null
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        setState(function (st) {
                              return {
                                      sortBys: st.sortBys.filter(function (param, i) {
                                            return i !== idx;
                                          })
                                    };
                            });
                      }),
                    title: "Delete",
                    children: Caml_option.some(React.createElement(DeleteForever, {}))
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        if (idx < (state.sortBys.length - 1 | 0)) {
                          return setState(function (st) {
                                      var copy = st.sortBys.slice();
                                      var tmp = copy[idx + 1 | 0];
                                      copy[idx + 1 | 0] = copy[idx];
                                      copy[idx] = tmp;
                                      return {
                                              sortBys: copy
                                            };
                                    });
                        }
                        
                      }),
                    title: "Move down",
                    children: Caml_option.some(React.createElement(ArrowDownward, {}))
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        if (idx > 0) {
                          return setState(function (st) {
                                      var copy = st.sortBys.slice();
                                      var tmp = copy[idx - 1 | 0];
                                      copy[idx - 1 | 0] = copy[idx];
                                      copy[idx] = tmp;
                                      return {
                                              sortBys: copy
                                            };
                                    });
                        }
                        
                      }),
                    title: "Move up",
                    children: Caml_option.some(React.createElement(ArrowUpward, {}))
                  }));
  };
  var rndSortControls = function (param, idx) {
    return JsxPPXReactSupportU.createElementVariadicWithKey(idx.toString(), Expln_React_Row.make, {
                alignItems: "center",
                children: Caml_option.some(null)
              }, [
                rndSortByButtons(idx),
                React.createElement(FormControl, {
                      size: "small",
                      children: Caml_option.some(React.createElement(Select, {
                                value: MM_wrk_sort_asrts.sortByToStr(param[0]),
                                onChange: Expln_React_common.evt2str(function (str) {
                                      var newSortBy = MM_wrk_sort_asrts.sortByFromStr(str);
                                      setState(function (st) {
                                            return {
                                                    sortBys: st.sortBys.map(function (param, i) {
                                                          var sortDir = param[1];
                                                          if (i === idx) {
                                                            return [
                                                                    newSortBy,
                                                                    sortDir
                                                                  ];
                                                          } else {
                                                            return [
                                                                    param[0],
                                                                    sortDir
                                                                  ];
                                                          }
                                                        })
                                                  };
                                          });
                                    }),
                                children: Caml_option.some(MM_wrk_sort_asrts.allSortByOptions.map(function (param) {
                                          var code = param[1];
                                          return JsxPPXReactSupportU.createElementWithKey(code, MenuItem, {
                                                      value: code,
                                                      children: Caml_option.some(param[2])
                                                    });
                                        }))
                              }))
                    }),
                React.createElement(FormControl, {
                      size: "small",
                      children: Caml_option.some(React.createElement(Select, {
                                value: MM_wrk_sort_asrts.sortDirToStr(param[1]),
                                onChange: Expln_React_common.evt2str(function (str) {
                                      var newSortDir = MM_wrk_sort_asrts.sortDirFromStr(str);
                                      setState(function (st) {
                                            return {
                                                    sortBys: st.sortBys.map(function (param, i) {
                                                          var sortBy = param[0];
                                                          if (i === idx) {
                                                            return [
                                                                    sortBy,
                                                                    newSortDir
                                                                  ];
                                                          } else {
                                                            return [
                                                                    sortBy,
                                                                    param[1]
                                                                  ];
                                                          }
                                                        })
                                                  };
                                          });
                                    }),
                                children: Caml_option.some(MM_wrk_sort_asrts.allSortDirOptions.map(function (param) {
                                          var code = param[1];
                                          return JsxPPXReactSupportU.createElementWithKey(code, MenuItem, {
                                                      value: code,
                                                      children: Caml_option.some(param[2])
                                                    });
                                        }))
                              }))
                    })
              ]);
  };
  return React.createElement(Expln_React_Column.make, {
              spacing: 1,
              children: Caml_option.some(null)
            }, state.sortBys.map(rndSortControls), React.createElement(FormControl, {
                  size: "small",
                  children: Caml_option.some(null)
                }, React.createElement(InputLabel, {
                      id: "sortBy-add-new-item",
                      children: "Select property to sort by"
                    }), React.createElement(Select, {
                      sx: {
                        width: 250
                      },
                      labelId: "sortBy-add-new-item",
                      label: "Select property to sort by",
                      value: "",
                      onChange: Expln_React_common.evt2str(function (str) {
                            var sortBys = MM_wrk_sort_asrts.sortByFromStr(str);
                            var sortDir = "Asc";
                            setState(function (st) {
                                  return {
                                          sortBys: Belt_Array.concatMany([
                                                st.sortBys,
                                                [[
                                                    sortBys,
                                                    sortDir
                                                  ]]
                                              ])
                                        };
                                });
                          }),
                      children: Caml_option.some(Belt_Array.concatMany([
                                [JsxPPXReactSupportU.createElementWithKey("", MenuItem, {
                                        value: "",
                                        children: ""
                                      })],
                                MM_wrk_sort_asrts.allSortByOptions.map(function (param) {
                                      var code = param[1];
                                      return JsxPPXReactSupportU.createElementWithKey(code, MenuItem, {
                                                  value: code,
                                                  children: Caml_option.some(param[2])
                                                });
                                    })
                              ]))
                    })), React.createElement(Expln_React_Row.make, {
                  alignItems: "center",
                  children: Caml_option.some(null)
                }, React.createElement(Button, {
                      onClick: (function (param) {
                          onOk(state.sortBys);
                        }),
                      variant: "contained",
                      children: "Ok"
                    }), React.createElement(Button, {
                      onClick: (function (param) {
                          onCancel();
                        }),
                      children: "Cancel"
                    })));
}

var make = MM_cmp_sort_asrts_selector;

exports.renderSortBys = renderSortBys;
exports.make = make;
/* react Not a pure module */
